import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  ElementRef,
  Input,
  Inject,
  Output,
  OnInit,
  OnDestroy,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DOCUMENT } from '@angular/common';

import { LoaderComponent } from '../../loader/loader.component';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'panel-modal',
  templateUrl: 'panel-modal.component.html',
  styleUrls: ['panel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelModalComponent implements OnInit, OnDestroy, OnChanges {
  @Input() showSaveBtn: boolean = true;

  @Input() hasNavigation: boolean = true;

  @Input() rightPanelMoved: boolean = false;

  @Input() sidenavActions: boolean = false;

  @Input() saving: boolean = false;

  @Output() saveClick: EventEmitter<any> = new EventEmitter();

  @Output() cancelClick: EventEmitter<any> = new EventEmitter();

  @Output() onHidden: EventEmitter<any> = new EventEmitter();

  @Output() onShown: EventEmitter<any> = new EventEmitter();

  @ViewChild('bsModal', {static: true}) bsModal: ModalDirective;

  @ViewChild('segmentsContent', {static: false}) segmentsContent: ElementRef;

  @ViewChild(LoaderComponent, {static: true}) loader: LoaderComponent;

  isModalShown: boolean = false;

  private modalOpenedClassName: string = 'page-modal-open';
  private isActive: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _renderer: Renderer2,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.saving) {
      this.showLoader(changes.saving.currentValue);
    }
  }

  ngOnInit() {
    this.bsModal.onShown
    .pipe(takeWhile(() => this.isActive))
    .subscribe(() => {
      this.isModalShown = true;
      this.ref.markForCheck();
      this.onShown.emit();
    });
    this.bsModal.onHidden
    .pipe(takeWhile(() => this.isActive))
    .subscribe(() => {
      this.isModalShown = false;
      this.ref.markForCheck();
      this.onHidden.emit(true);
    });
  }

  ngOnDestroy() {
    this.hide();
    this.isActive = false;
  }

  // handlers
  onSaveClick() {
    this.saveClick.emit();
  }

  onCancelClick() {
    this.cancelClick.emit();
  }

  // public
  public show(): void {
    this._renderer.addClass(document.body, this.modalOpenedClassName);
    this.bsModal.show();
  }

  public hide(): void {
    this._renderer.removeClass(document.body, this.modalOpenedClassName);
    this.saving = false;
    this.bsModal.hide();
  }

  public scrollContentTop(): void {
    this.segmentsContent.nativeElement.scrollTop = 0;
  }

  public showLoader(show: boolean): void {
    if (show) {
      this.loader.show();
    } else {
      if (this.loader.isShow) { this.loader.hide(); }
    }
    this.ref.markForCheck();
  }
}
